import React, { Component } from 'react';
import '../../CSS/assets-minified/all-demo.css'

class LeftHeaderDropdown extends Component{

      render(){
          return(
              <div>
                <div id="header-left">  

            </div>
               </div>
          
          )
      }

}

export default LeftHeaderDropdown;


// WEBPACK FOOTER //
// src/components/dashboardSubComponents/left-header-dropdown.js